namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_token_view, {
		
		position: 'relative',

		Logo: {
			position: 'absolute',
			left: '-4px',
			top: '-4px',
		},

		Avatar: {
			height: '2rem',
			width: '2rem',
			border: {
				radius: '50%',
			},
		}
		
	} )
	
}
